import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { PageHeaderSection } from "../../components/common/PageHeadSection";
import { Skeleton, Spin, TablePaginationConfig } from "antd";
import _ from "lodash";
import { StopFreeSaleService } from "../../services/StopFreeSaleService";
import { setPdfExportObject } from "../../store/SiteSlice";
import { mdlStopFreeSaleListRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleListRequest";
import { StopFreeSaleTable } from "../../components/stop-free-sale/StopFreeSaleTable";
import { ExpandableStopFreeSaleList } from "../../components/stop-free-sale/ExpandableStopFreeSaleList";
import { faFire,  faWater } from "@fortawesome/free-solid-svg-icons";
import { HeaderButton } from "../../models/ui-models/HeaderButton";
import { enmPdfExportType } from "../../models/enums/PdfExportType";
import { mdlStopFreeSaleExport } from "../../models/domain/StopFreeSaleExport";
import { mdlPDFRendererProps } from "../../models/ui-models/PDFRendererProps";
import { enmPdfRendererType } from "../../models/enums/PdfRenderer";
import { SFModal } from "../../components/elements/SFModal";
import { StopFreeSaleExportEmail } from "../../components/stop-free-sale/StopFreeSaleExportEmail";
import { useLocation, useNavigate } from "react-router-dom";
import { routeContants } from "../../utils/RouteConstants";
import { enmStopFreeSale } from "../../models/enums/StopFreeSale";
import { mdlStopFreeSaleDetail } from "../../models/domain/StopFreeSaleDetail";
import { mdlStopFreeSaleMessage } from "../../models/domain/StopFreeSaleMessage";
import { AgencyEmailTemplate } from "../../components/stop-free-sale/AgencyEmailTemplate";
import { mdlStopFreeSale } from "../../models/domain/StopFreeSale";
import { mdlStopFreeSaleMailServiceRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleMailServiceRequest";
import { useAppDispatch, useAppSelector } from "../../store/Hooks";


export const AddUpdateStopFreeSale = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [request, setRequest] = useState<mdlStopFreeSaleListRequest>({pageNumber:1, pageSize:10});
    const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>();
    const [openEmailModal, setOpenEmailModal] = useState<boolean>(false);
    const [exportData, setExportData] = useState<mdlStopFreeSaleExport>();
    const [openAgencyEmailModal, setOpenAgencyEmailModal] = useState<boolean>(false);
    const [detailData, setDetailData] = useState<mdlStopFreeSaleDetail[]>();
    const [message, setMessage] = useState<mdlStopFreeSaleMessage>();  
    const [spinner, setSpinner] = useState<boolean>(false);  
    const siteStore = useAppSelector((state) => state.site);
    const [stopFreeSaleType, setStopFreeSaleType] = useState<enmStopFreeSale>(enmStopFreeSale.StopSale);

    useEffect(() => {
        if (location && location.state && location.state.type) {
            setStopFreeSaleType(location.state.type)
        }
        if (!dataList){
            refetchList();
        }
    }, []);

    //#region API CALLS

    const getMailService = useMutation({
        mutationFn: (id:string) => {
          return StopFreeSaleService.GetMailService({stopFreeId: id} as mdlStopFreeSaleMailServiceRequest)
        },
      })

    const mailMutateOperations = (id:string, fnModal:Function) => {
        setSpinner(true);
        setExportData(undefined);
        setMessage(undefined);
        setDetailData(undefined);
        getMailService.mutate(id, {
          onSuccess(data){
              if(data && data.body && data.header.success){
                    setExportData(({..._.first(data.body.mailData),["id"]:id}) as mdlStopFreeSaleExport);
                    setMessage(data.body.messages);
                    setDetailData(data.body.details?.map( x=> ({...x,["id"]:id})))
                    fnModal && fnModal();
              }
          },
          onSettled(data, error, variables, context) {
            setSpinner(false);
          },
        })
    }

    const {
        data: dataList,
        isLoading : isLoadingList,
        refetch:refetchList
    } = useQuery(
        ["getList", request],
        () => {
            return StopFreeSaleService.GetList({...request, IsSend:false, displayLength:_pagination.defaultPageSize, displayStart:_pagination.current });
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!request,
        }
    );

    const handleAgencyMailPreview = (e:any) => {
        if(e.id == exportData?.id){
            setOpenAgencyEmailModal(true);
            return;
        }
        mailMutateOperations(e.id,(data:any) => { setOpenAgencyEmailModal(true)});
    }
    const handleEmailClick = (id:string) => {
        if(id == exportData?.id){
            setOpenEmailModal(true);
            return;
        }
        mailMutateOperations(id,(data:any) => { setOpenEmailModal(true)});
    }

    const handlePrintClick = (id:string) => {
        if(id == exportData?.id){
            var exportProps: mdlPDFRendererProps = {
                params: { dataSource: exportData, message:message, detail:detailData },
                rendererType: enmPdfRendererType.StopFreeSaleTemplate,
                type: enmPdfExportType.PRINT
            }
            dispatch(setPdfExportObject(exportProps));
            return;
        }
        mailMutateOperations(id,(data:any) => { 
            var exportProps: mdlPDFRendererProps = {
                params: { dataSource: exportData, message:message, detail:detailData },
                rendererType: enmPdfRendererType.StopFreeSaleTemplate,
                type: enmPdfExportType.PRINT
            }
            dispatch(setPdfExportObject(exportProps));

        });
        
    }

    const handlePdfClick = (id:string) => {
        if(id == exportData?.id){
            var exportProps: mdlPDFRendererProps = {
                params: { dataSource: exportData, message:message, detail:detailData },
                rendererType: enmPdfRendererType.StopFreeSaleTemplate,
                type: enmPdfExportType.PDF
            }
            dispatch(setPdfExportObject(exportProps));
            return;
        }
        
        mailMutateOperations(id,(data:any) => { 
            var exportProps: mdlPDFRendererProps = {
                params: { dataSource: exportData, message:message, detail:detailData },
                rendererType: enmPdfRendererType.StopFreeSaleTemplate,
                type: enmPdfExportType.PDF
            }
            dispatch(setPdfExportObject(exportProps));
        });
    }
    
    const handleTableParamsChange = (filters: any) => {}
    const onRowSelect = (filters: any) => {}

    const handleExpandRowRenderer = (id: string) => {
        return <ExpandableStopFreeSaleList id={id} />
    }

    const handlePaginationChange = (page: number, pageSize: number) => {
        const _request = { ...request, pageSize: pageSize ?? 10, pageNumber: page ?? 1 };
        setRequest(_request)
    }
    const handelEditClick = (e:mdlStopFreeSale) => {
        navigate(routeContants.STOP_FREE_SALE_CREATE, {state:{data : e, type : e.type != undefined && e.type ? e.type : enmStopFreeSale.StopSale}}) 
    }
    const handleAddNewStopSale = () => {
        navigate(routeContants.STOP_FREE_SALE_CREATE, {state:{type : enmStopFreeSale.StopSale}}) 
    }
    const handleAddNewFreeSale = () => {
        navigate(routeContants.STOP_FREE_SALE_CREATE, {state:{type : enmStopFreeSale.FreeSale}}) 
    }

    const getButtons = ():HeaderButton[] | undefined => {
        let stopMode = false;
        let freeMode = false;
        console.log(location)
        if (location && location.state && location.state.type) {
            freeMode = location.state.type == enmStopFreeSale.FreeSale;
            stopMode = location.state.type == enmStopFreeSale.StopSale;
        }
        let _buttons:HeaderButton[] = [];
        if(!location.state || ( location && stopMode)){
            _buttons.push({
                title:t("stopFreeSale.stopSale.addNew"),
                icon: faWater,
                fnFunction:handleAddNewStopSale,
                className:"btn btn-white btn-outline-secondary"
            });
        }
        if(!location.state || ( location && freeMode)){
            _buttons.push({
                title:t("stopFreeSale.freeSale.addNew"),
                icon: faFire,
                fnFunction:handleAddNewFreeSale,
                className:"btn btn-white btn-outline-primary"
            });
        }
        return _buttons;
    }
    const _pagination =  {
            align: "center",
            current: dataList?.body?.pageNumber,
            pageSizeOptions: [10, 20, 50],
            defaultPageSize: 10,
            pageSize: dataList?.body?.resultCount,
            defaultCurrent: 1,
            responsive: true,
            showSizeChanger: true,
            total: dataList?.body?.totalCount,
            showTotal: (total: number, range: [number, number]) => t("pagination.total") + ` ${dataList?.body?.totalCount} ` + t("pagination.result"),
            locale: { items_per_page: "/ " + t("pagination.itemPerPage") }
    } as TablePaginationConfig;

    return (
        <>
            <SFModal
                width={window.innerWidth > 768 ?  (window.innerWidth * 50 / 100) : window.innerWidth}
                open={openEmailModal}
                toggler={() => { setOpenEmailModal(!openEmailModal) }}
                body={<StopFreeSaleExportEmail closePopup={() => { setOpenEmailModal(false) }} fnAgencyMailPreview={handleAgencyMailPreview} dataSource={exportData} detail={detailData} message={message}/>}
                title={t("stopFreeSale.emailTitle")}
            />
            <SFModal
                width={window.innerWidth > 768 ?  (window.innerWidth * 50 / 100) : window.innerWidth}
                open={openAgencyEmailModal}
                toggler={() => { setOpenAgencyEmailModal(!openAgencyEmailModal) }}
                body={<AgencyEmailTemplate  stopFreeSaleType={stopFreeSaleType} activeUser={siteStore.user} dataSource={exportData} detail={ detailData} message={message} />}
                title={stopFreeSaleType == enmStopFreeSale.StopSale   ? `t("stopSaleMailTemplate.emailTitleStop")` : t("stopSaleMailTemplate.emailTitleFree")}
            />
            <div className="nk-content ">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <PageHeaderSection
                                pageTitle={t("stopFreeSale.title")}
                                buttons={getButtons()}
                            />
                            <div className="nk-block">
                                <div className="card card-bordered h-100">
                                    <div className="card-inner">

                                    {
                                                    isLoadingList
                                                    &&
                                                    <>
                                                        <Skeleton active />
                                                        <Skeleton active />
                                                        <Skeleton active />
                                                    </>
                                                }
                                                {
                                                    dataList
                                                    &&
                                                    <Spin spinning={spinner}>
                                                        <StopFreeSaleTable
                                                            unVisibleColumns={["mailSubject"]}
                                                            onDelete={handelEditClick}
                                                            onEditClick={handelEditClick}
                                                            onEmailClick={handleEmailClick}
                                                            onPrintClick={handlePrintClick}
                                                            onPDFClick={handlePdfClick}
                                                            onRowSelection={onRowSelect}
                                                            selectedRowKeys={selectedRowKeys}
                                                            expandRowRenderer={handleExpandRowRenderer}
                                                            onPaginationChange={handlePaginationChange}
                                                            pagination={_pagination}
                                                            onTableParamsChange={handleTableParamsChange}
                                                            dataSource={dataList?.body?.data}
                                                        />
                                                    </Spin>
                                                }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>


    );
};